import { useTranslation } from "react-i18next";

import { cn } from "@/lib/utils";

export const AppVersion = ({ className }: { className?: string }) => {
  const { t } = useTranslation();

  return (
    <p className={cn("text-muted-foreground text-sm text-center", className)}>
      {`${t("version")} ${__APP_VERSION__}`}
    </p>
  );
};
